import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF5754",         // Main color: red
      contrastText: "#fafafa",  // Text on primary backgrounds: white
      dark: "#E04540",         // (Optional) a darker variant for hovers
    },
    secondary: {
      main: "#171717",         // Secondary color: black (used for backgrounds)
    },
    background: {
      default: "#171717",      // Default background color
      paper: "#171717",
    },
    text: {
      primary: "#fafafa",      // All text white
      secondary: "#fafafa",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

export default theme;